import React from "react";

// Stacked discs along Z give the coin real cylindrical thickness.
const EDGE_SLICES = Array.from({ length: 17 }, (_, i) => i - 8);

const CoinFace = ({ variant, emblem }) => (
  <span className={`bcoin-cface bcoin-cface-${variant}`} aria-hidden>
    <span className="bcoin-cface-rim" />
    <span className="bcoin-cface-star top">✦</span>
    <span className="bcoin-cface-emblem">{emblem}</span>
    <span className="bcoin-cface-star bottom">✦</span>
    <span className="bcoin-cface-micro">{variant === "heads" ? "BOND · HEADS" : "BOND · TAILS"}</span>
    <span className="bcoin-cface-glare" />
  </span>
);

const CoinTossStage = ({ outcome = null, spinning = false, locked = false }) => {
  const stateClass = spinning
    ? " bcoin-toss-spinning"
    : outcome
      ? ` bcoin-toss-${outcome}`
      : locked
        ? " bcoin-toss-locked"
        : " bcoin-toss-idle";

  return (
    <div className={`bcoin-toss${stateClass}`} aria-hidden>
      <div className="bcoin-toss-orbit" />
      <div className="bcoin-toss-trail" aria-hidden />
      <div className="bcoin-toss-scene">
        <div className="bcoin-toss-coin">
          <span className="bcoin-cedge-stack" aria-hidden>
            {EDGE_SLICES.map((z) => (
              <span key={z} className="bcoin-cedge" style={{ transform: `translateZ(${z}px)` }} />
            ))}
          </span>
          <CoinFace variant="heads" emblem="H" />
          <CoinFace variant="tails" emblem="T" />
        </div>
      </div>
      <span className="bcoin-toss-spark s1" aria-hidden />
      <span className="bcoin-toss-spark s2" aria-hidden />
      <span className="bcoin-toss-spark s3" aria-hidden />
      <div className="bcoin-toss-shadow" />
    </div>
  );
};

export default CoinTossStage;
